import { Model } from "@bryntum/schedulerpro";
import { HasProjectMixin } from "./mixins/HasProjectMixin.jsx";
import { STORE_KEYS } from "../../other/constants/StoreKeys.jsx";

export class TaskPlanningDates extends HasProjectMixin(Model) {
  static get $name() {
    return "TaskPlanningDates";
  }

  static get relations() {
    return {
      taskRecord: {
        foreignKey: "taskId",
        foreignStore: STORE_KEYS.taskStore,
        relatedCollectionName: "planningDatesRecords",
      },
    }
  }

  static get fields() {
    return [
      { name: "name", dataSource: "name" },
      { name: "startDate", dataSource: "start_date", type: "date" },
      { name: "endDate", dataSource: "end_date", type: "date" },
      { name: "taskId", dataSource: 'task', type: "number" },
      { name: "color", dataSource: "color" }
    ];
  }
}
